import React from 'react';
import cn from 'classnames';
import { View } from 'src/components/common';
import './styles.scss';
import { IRootState } from 'src/redux/rootReducer';
import { connect } from 'react-redux';

const CustomModal: React.FC<Props> = ({ openModalType, body, header, className, containerClassName }) => {
  return (
    <View
      className={cn(
        'cmp-custom-modal',
        { 'cmp-custom-modal--show': openModalType },
        { 'cmp-custom-modal--hide': openModalType === false },
        className,
      )}>
      <View className={cn('cmp-custom-modal__background')}>
        <View className={cn('cmp-custom-modal__container', containerClassName)}>
          {!!header && <View className={cn('cmp-custom-modal__title', 'mb-5')}>{header}</View>}
          {body}
        </View>
      </View>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
    openModalType: string | false | null;
    body?: React.ReactNode | string;
    header?: React.ReactNode | string;
    containerClassName?: string;
  };

const mapStateToProps = (state: IRootState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CustomModal);
